import axios from 'axios';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/format';
import apiClient from './apiClient';

export const getProgressConsolidatedPerformance = async (idProject: number): Promise<any> => {
    try {
        const response = await apiClient.get(`/ConsolidatedPerformance/progress/${idProject}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching progress consolidated performance:', error);
        throw error;
    }
};

/**
 * Consolidado de rendimiento de una actividad, replicando la hoja
 * "Consolidado Rendimientos" del informe SGR. Distingue la visión Efectiva
 * (effective*) de la visión Total / Con improductividades (total*).
 */
export interface ConsolidatedYieldActivity {
    idActivity: number;
    section: string;
    name: string;
    subActivity: string;
    unitOfMeasurement: string;
    unitOfMeasurementProduction: string;
    /** Unidad concreta de esta fila (la principal de producción o la secundaria de avance). */
    unit: string;
    /** true si la fila es la unidad secundaria (avance), false si es la principal. */
    secondary: boolean;
    daysTotal: number;
    daysEffective: number;
    hhTotal: number;
    hmTotal: number;
    hhEffective: number;
    hmEffective: number;
    production: number;
    effectiveProductionPerDay: number;
    totalProductionPerDay: number;
    effectiveYieldHh: number;
    effectiveYieldHm: number;
    totalYieldHh: number;
    totalYieldHm: number;
    yieldGoalHhPo: number;
    yieldGoalHmPo: number;
    productionGoalPo: number;
    /** Oferta: carga manual en la matriz de actividades. Llega null en la fila secundaria (avance). */
    productionGoalOffer: number | null;
    yieldGoalHhOffer: number | null;
    yieldGoalHmOffer: number | null;
}

export interface ConsolidatedYieldResponse {
    idProject: number;
    nameProject: string;
    activities: ConsolidatedYieldActivity[];
}

/**
 * Obtiene el consolidado de rendimientos por actividad calculado en el backend
 * (endpoint /ConsolidatedPerformance/yield/{projectId}).
 */
export const getConsolidatedYield = async (projectId: number, startDate?: string, finishDate?: string): Promise<ConsolidatedYieldResponse> => {
    try {
        const formattedStartDate = startDate ? format(parseISO(startDate), "yyyy-MM-dd'T'HH:mm:ss") : undefined;
        const formattedFinishDate = finishDate ? format(parseISO(finishDate), "yyyy-MM-dd'T'HH:mm:ss") : undefined;

        const response = await apiClient.get(`/ConsolidatedPerformance/yield/${projectId}`, {
            params: {
                startDate: formattedStartDate,
                finishDate: formattedFinishDate
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching consolidated yield by project:', error);
        throw error;
    }
};

export const getWorkFrontDetailsByProject = async (projectId: number, startDate?: string, finishDate?: string): Promise<any[]> => {
    try {
        const formattedStartDate = startDate ? format(parseISO(startDate), "yyyy-MM-dd'T'HH:mm:ss") : undefined;
        const formattedFinishDate = finishDate ? format(parseISO(finishDate), "yyyy-MM-dd'T'HH:mm:ss") : undefined;

        const response = await apiClient.get(`/ConsolidatedPerformance/totalProduccion/dailyReport/${projectId}`, {
            params: {
                startDate: formattedStartDate,
                finishDate: formattedFinishDate
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching work front details by project:', error);
        throw error;
    }
};